import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import PropTypes from '../helpers/propTypes';

export function Title(props) {
  return <Typography {...props} variant="h1" />;
}

export function MainHeading({ noUnderline, ...props }) {
  return (
    <Typography
      {...props}
      underline={noUnderline ? 'false' : 'true'}
      variant="h2"
    />
  );
}

MainHeading.propTypes = {
  noUnderline: PropTypes.bool,
};

MainHeading.defaultProps = {
  noUnderline: false,
};

const useHeadingSmallerStyles = makeStyles({
  root: {
    fontWeight: 600,
    fontSize: 16,
    marginBottom: 20,
    marginTop: 20,
    lineHeight: '22px',
  },
});

export const MainHeadingSmaller = function MainHeadingSmaller({
  align,
  ...props
}) {
  const classes = useHeadingSmallerStyles();

  return (
    <Typography
      {...props}
      classes={classes}
      style={{ textAlign: align }}
      variant="h2"
    />
  );
};

MainHeadingSmaller.propTypes = {
  // `right` is intentionally disallowed here as it doesn't align with the current design.
  align: PropTypes.oneOf(['left', 'center']),
};

MainHeadingSmaller.defaultProps = {
  align: 'left',
};

export function SectionHeading(props) {
  return <Typography {...props} variant="h3" />;
}

export function NormalText(props) {
  return <Typography {...props} variant="body1" />;
}

export function SubtleText(props) {
  return <Typography {...props} variant="body2" />;
}
